<script>
	import Step1 from "./Steps/Step1.svelte";
	import Step2 from "./Steps/Step2.svelte";			
	import Step3 from "./Steps/Step3.svelte";				

  import Footer from "./General/Footer.svelte";

  export let currrentStep = 1;
  const showMenu = () => {
    document.getElementsByClassName("panel-1")[0].classList.toggle("hide");
    document.getElementsByClassName("panel-0")[0].classList.toggle("d-none");
    document.getElementsByClassName("menu-wrapper")[0].classList.toggle("menu-wrapper-on");
    document.getElementsByClassName("menu-toggle")[0].classList.toggle("fa-bars");
    document.getElementsByClassName("menu-toggle")[0].classList.toggle("fa-times");
  };
</script>

<main
  class="d-flex flex-column align-items-stretch flex-grow-1 scrollarea"
  style="height:100vh;max-height:100vh"
>
  <div class="container-fluid m-0 p-0">
    <div class="row m-0 p-0">
      <div class="col-12 m-0 p-0">
        <div class="container p-0">
          <div class="row p-0 pb-5">
            <div class="col p-0">
              <div
                class="jumbotron container mt-4 p-4 bg-light-transparent rounded"
              >
                <div class="row">
                  <div
                    class="col-sm-12 col-md-6 col-lg-6 order-2 order-xs-2 order-sm-2 order-md-1"
                  >
                  </div>
                  <div
                    class="col-sm-12 col-md-6 col-lg-6 order-1 order-xs-1 order-sm-1 order-md-2 text-end"
                  >
                    <a href="/" class="btn btn-secondary"> Sign In </a>
                  </div>
                </div>

                <div class="row pt-5 mt-5">
                  <div class="col-sm-12 col-md-12 col-lg-12">
                    <div class="card border-secondary">
                      <div class="card-header bg-campus text-white">
                        Reset Password
                      </div>

                      {#if currrentStep==1}

                        <Step1 bind:currrentStep/>

                      {:else if currrentStep==2}

                        <Step2  bind:currrentStep/>

                      {:else if currrentStep==3}

                        <Step3  bind:currrentStep/>

                      {/if}
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container p-0 mt-5">
          <Footer />
        </div>
      </div>
    </div>
  </div>
</main>
